export default class Forms {
    constructor() {
        this.init();
    }

    init() {

        // --- CF7 ERROR MESSAGE ---
        const errorMessageWrap = document.querySelectorAll(".wpcf7-form-control-wrap");
        for (const wrap of errorMessageWrap) {
            wrap.addEventListener("click", hideErrorMessage);
            wrap.addEventListener("focus", hideErrorMessage, true);
        }
        function hideErrorMessage() {
            const errorTip = this.querySelector(".wpcf7-not-valid-tip");
            if (errorTip) {
                errorTip.style.display = "none";
            }
        }

        // --- CF7 NOT-VALID ---
        const notValidWrap = document.querySelectorAll(".wpcf7-form-control-wrap");
        for (const wrap of notValidWrap) {
            wrap.addEventListener("click", removeNotValidClass);
            wrap.addEventListener("focus", removeNotValidClass, true);
        }
        function removeNotValidClass() {
            const formControl = this.querySelector(".wpcf7-form-control");
            if (formControl && formControl.classList.contains("wpcf7-not-valid")) {
                formControl.classList.remove("wpcf7-not-valid");
            }
        }

    }

}
